<template>
  <div>
    <appModal></appModal>
    <appHeader></appHeader>
    <div class="container-fluid customer-orders">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Batch Process</h4>
            <div>
              <div
                class="my-2 p-2"
                :style="`border: 1px solid ${newMsg.color}; color: ${newMsg.color}`"
                v-if="newMsg.message"
              >
                <b v-html="newMsg.message">
                </b>
              </div>
              <div
                class="my-2 p-2"
                :style="`border: 1px solid ${msg.color}; color: ${msg.color}`"
                v-if="!newMsg.message && msg.message"
              >
                <b v-html="msg.message">
                </b>
              </div>
              <h6>Filters</h6>
              <batchProcessForm class="mt-4"></batchProcessForm>
              <div class="container-fluid">
                <router-view />
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import BatchProcessForm from "./BatchProcessForm.vue";
import divvyAdminModal from "@/components/divvyAdminModal.vue";

export default {
  name: "BatchProcess",
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
    batchProcessForm: BatchProcessForm,
    appModal: divvyAdminModal,
  },
  methods: {
    setActiveMenuItem: function () {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "batchProcess",
        activeMenu: this.activeMenu ? this.activeMenu : "crm-tools",
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },

  created() {
    this.setActiveMenuItem();
    this.scrollToTop();
  },

  computed: {
    Message() {
      return this.$store.getters["batchProcess/getViewBatchUpdateMessage"];
    },
    msg() {
      return this.$store.getters["batchProcess/getViewBatchMessage"];
    },
    newMsg() {
      return this.$store.getters["batchProcess/getBatchMessage"];
    },
  },
};
</script>
<style lang="scss" scoped>
.customer-orders {
  //   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.marginAll {
  margin: 10px;
}

html,
body {
  height: 100%;
}
</style>
